import { z } from 'zod';

export type VoucherFormSchemaValues = z.infer<typeof voucherFormSchema>;
export const voucherFormSchema = z.object({
    voucher_type: z.string().nonempty(),
    customer: z.string().optional().nullable(),
});
